import AvailableModes from '../components/AvailableOptions/AvailableModes';

function RecordDurationCalculations({ bitRateTotal, storageResult, storageUnits, mode, setDays, setHours, setMinutes, minutes }) {
  if (bitRateTotal !== 0 && storageResult !== 0) {
    let durationInSeconds = storageResult / bitRateTotal;
    storageUnits.value === 'GigaBytes'
      ? (durationInSeconds = (storageResult * 1000) / bitRateTotal)
      : storageUnits.value === 'TeraBytes'
      ? (durationInSeconds = (storageResult * 1000000) / bitRateTotal)
      : (durationInSeconds = storageResult / bitRateTotal);
    let durationInSecondsRound = parseFloat(durationInSeconds).toFixed(2);

    if (mode.value === AvailableModes[1].value) {
      let durationInDays = parseInt(durationInSecondsRound / (24 * 60 * 60));
      let durationInHours = parseInt((durationInSecondsRound % (24 * 60 * 60)) / (60 * 60));
      let durationInMinutes = parseInt(((durationInSecondsRound % (24 * 60 * 60)) % (60 * 60)) / 60);
      setDays(durationInDays);
      setHours(durationInHours);
      setMinutes(durationInMinutes);
    }

    if (mode.value === AvailableModes[0].value) {
      let durationInDays = 0;
      let durationInMinutes = minutes;
      let durationInHours = parseInt(durationInSecondsRound / (60 * 60));
      setDays(durationInDays);
      setHours(durationInHours);
      setMinutes(durationInMinutes);
    }
  }
}

export default RecordDurationCalculations;
